export const defaultStyles = {
  backgroundColor: "var(--theme-email-color-background-secondary)",
  color: "var(--theme-email-color-4)",
  padding: {
    paddingTop: "56",
    paddingBottom: "56",
    paddingLeft: "0",
    paddingRight: "0",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
} as const;
